export const PAY_MODES = [
    ["hodinova", "Hodinová zakázka"],
    ["na_klic", "Zakázka na klíč"],
];

export const payModeLabel = (m) => (m === "na_klic" ? "Na klíč" : "Hodinová");
export const isPiecework = (job) => job?.pay_mode === "na_klic";

export function PayModeBadge({ mode, testid }) {
    const klic = mode === "na_klic";
    return (
        <span data-testid={testid}
              className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${
                  klic ? "bg-amber-50 text-amber-800 border-amber-400" : "bg-sky-50 text-sky-800 border-sky-300"}`}>
            {payModeLabel(mode)}
        </span>
    );
}
